import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Text } from 'src/Components'
import { IconBuoy } from 'src/Components/shared/Icon'
import { Heading, ProConList, Pro } from 'src/Components/shared/Gem/GemDetail'
import {
  ADD_SPACE,
  ELIMINATE_CREDIT_CARD_DEBT,
  SOLAR_PANELS
} from 'src/constants/gems'
import { definitions } from 'src/Components/shared/Gem/gems'

import styles from './Eurotrip.module.scss'

const options = [ELIMINATE_CREDIT_CARD_DEBT, ADD_SPACE, SOLAR_PANELS]

const Eurotrip = ({ close }) => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.eurotripHeading'
        defaultMessage='You probably shouldn’t use your home equity to vacation. Taking a dip in the Mediterranean should be on your bucket list, but use your discretionary income. Home equity is best used for wealth-building activities or paying down debt.'
      />
    </Heading>

    <Heading>
      <FormattedMessage
        id='Homeowner.equity.eurotripSubHeading'
        defaultMessage='Try these options instead:'
      />
    </Heading>

    <ProConList className={styles.list}>
      {options.map(key => (
        <Pro key={key}>{definitions[key].title}</Pro>
      ))}
    </ProConList>

    <Text align='center'>
      <Button onClick={close} iconStart={IconBuoy}>
        <FormattedMessage
          id='Homeowner.equity.eurotripSafety'
          defaultMessage='See better options'
        />
      </Button>
    </Text>
  </div>
)

export default Eurotrip
